module.exports = __webpack_public_path__ + "static/gallery-21-8fa3da8b9c3351e2c7f56e3721a7f8ab.jpg";